<!--
  -  TTTech nerve-ui-components
  -  Copyright(c) 2021. TTTech Industrial Automation AG.
  -
  -  ALL RIGHTS RESERVED.
  -
  -  Usage of this software, including source code, netlists, documentation,
  -  is subject to restrictions and conditions of the applicable license
  -  agreement with TTTech Industrial Automation AG or its affiliates.
  -
  -  All trademarks used are the property of their respective owners.
  -
  -  TTTech Industrial Automation AG and its affiliates do not assume any liability
  -  arising out of the application or use of any product described or shown
  -  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
  -  make changes, at any time, in order to improve reliability, function or
  -  design.
  -
  -  Contact Information:
  -  support@tttech-industrial.com
  -
  -  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
  -
  -->

<template>
  <span>
    {{ timeInWords }}
  </span>
</template>

<script>
export default {
  props: {
    date: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      timeInWords: '',
      formatInterval: '',
    };
  },
  watch: {
    date() {
      this.timeInWords = this.format();
    },
  },
  created() {
    this.timeInWords = this.format();
    this.formatInterval = setInterval(() => {
      this.timeInWords = this.format();
    }, 1000 * 60);
  },
  beforeDestroy() {
    clearInterval(this.formatInterval);
  },
  methods: {
    format() {
      return new Date(this.date).toLocaleString('en-GB');
    },
  },
};
</script>

<style scoped>

</style>
